'use strict';

var defineProperty = require('../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
var makeStyles = require('../DesignSystem/Styles/makeStyles.js');
var colorManipulator = require('../node_modules/@material-ui/core/styles/colorManipulator.js');
var amber = require('../node_modules/@material-ui/core/colors/amber.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  var _theme$palette$alert;

  return {
    action: {
      backgroundColor: colorManipulator.fade(theme.palette.action.active, theme.palette.action.hoverOpacity)
    },
    disabled: {
      backgroundColor: colorManipulator.fade(theme.palette.action.disabled, theme.palette.action.hoverOpacity)
    },
    error: {
      backgroundColor: colorManipulator.fade(theme.palette.error.main, theme.palette.action.hoverOpacity)
    },
    primary: {
      backgroundColor: colorManipulator.fade(theme.palette.primary.main, theme.palette.action.hoverOpacity)
    },
    secondary: {
      backgroundColor: colorManipulator.fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
    },
    alert: {
      backgroundColor: colorManipulator.fade(((_theme$palette$alert = theme.palette.alert) === null || _theme$palette$alert === void 0 ? void 0 : _theme$palette$alert.main) || amber[600], theme.palette.action.hoverOpacity)
    },
    white: {
      backgroundColor: theme.palette.primary.light
    },
    backgroundCircleStyle: {
      borderRadius: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  };
});

var iconStyles = function iconStyles() {
  return function (WrappedComponent) {
    var IconStyles = function IconStyles(_ref) {
      var _ref$width = _ref.width,
          width = _ref$width === void 0 ? 24 : _ref$width,
          _ref$height = _ref.height,
          height = _ref$height === void 0 ? 24 : _ref$height,
          size = _ref.size,
          style = _ref.style,
          backgroundCircle = _ref.backgroundCircle,
          color = _ref.color,
          props = objectWithoutProperties(_ref, ["width", "height", "size", "style", "backgroundCircle", "color"]);

      var _useStyles = useStyles(),
          backgroundCircleStyle = _useStyles.backgroundCircleStyle,
          classes = objectWithoutProperties(_useStyles, ["backgroundCircleStyle"]);

      var sizedStyle = _objectSpread({
        height: height,
        width: width
      }, style);

      if (size === 'small') {
        sizedStyle.height = 16;
        sizedStyle.width = 16;
      }

      if (size === 'medium') {
        sizedStyle.height = 24;
        sizedStyle.width = 24;
      }

      if (size === 'large') {
        sizedStyle.height = 32;
        sizedStyle.width = 32;
      }

      if (size === 'xlarge') {
        sizedStyle.height = 44;
        sizedStyle.width = 44;
      }

      if (size === 'jumbo') {
        sizedStyle.height = 60;
        sizedStyle.width = 60;
      }

      if (size === 'superJumbo') {
        sizedStyle.height = 120;
        sizedStyle.width = 120;
      }

      if (backgroundCircle) {
        return React__default["default"].createElement("div", {
          style: {
            width: sizedStyle.width * 2,
            height: sizedStyle.height * 2
          },
          className: classNames__default["default"](backgroundCircleStyle, defineProperty({}, classes[color], color !== 'inherit'))
        }, React__default["default"].createElement(WrappedComponent, _objectSpread({
          color: color,
          style: sizedStyle
        }, props)));
      }

      return React__default["default"].createElement(WrappedComponent, _objectSpread({
        color: color,
        style: sizedStyle
      }, props));
    };

    return IconStyles;
  };
};

module.exports = iconStyles;
